import { render, staticRenderFns } from "./CustomerGroupProprtyForm.vue?vue&type=template&id=649b921e"
import script from "./CustomerGroupProprtyForm.vue?vue&type=script&lang=ts"
export * from "./CustomerGroupProprtyForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports